import {TransportCardPaymentHistoryItem} from '../../../models/api/transportCardPaymentHistory';

const mockResponse: TransportCardPaymentHistoryItem[] = [
  {
    date: '2022-01-03T17:30:18.632Z',
    amountInRubles: 100,
    payment: {
      code: 0,
      description: 'Пополнение через банкомат',
    },
  },
  {
    date: '2022-02-03T17:30:18.632Z',
    amountInRubles: 200,
    payment: {
      code: 0,
      description: 'Пополнение через банкомат',
    },
  },
  {
    date: '2022-03-03T17:30:18.632Z',
    amountInRubles: 100,
    payment: {
      code: 0,
      description: 'Пополнение через банкомат',
    },
  },
  {
    date: '2022-04-03T17:30:18.632Z',
    amountInRubles: 400,
    payment: {
      code: 0,
      description: 'Пополнение через банкомат',
    },
  },
  {
    date: '2022-05-03T17:30:18.632Z',
    amountInRubles: 1000,
    payment: {
      code: 0,
      description: 'Пополнение с оплатой наличными',
    },
  },
];

export default mockResponse;
